"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Email_1 = tslib_1.__importDefault(require("@mui/icons-material/Email"));
const Smartphone_1 = tslib_1.__importDefault(require("@mui/icons-material/Smartphone"));
const Grid_1 = tslib_1.__importDefault(require("@mui/material/Grid"));
const Skeleton_1 = tslib_1.__importDefault(require("@mui/material/Skeleton"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const styles_1 = require("@mui/material/styles");
const ICON_OPACITY = "0.54";
const getStyles = ({ theme }) => ({
    skeletonText: {
        flexGrow: 1,
    },
    skeletonGridContainer: {
        width: theme.spacing(30),
    },
    skeletonGridItem: {
        display: "flex",
        alignItems: "center",
    },
    icon: {
        marginRight: theme.spacing(1),
        fontSize: "inherit",
    },
});
const SkeletonInfoText = ({ instances, skeletonProps }) => {
    const theme = (0, styles_1.useTheme)();
    const styles = getStyles({ theme });
    return (react_1.default.createElement(react_1.default.Fragment, null, Array(instances)
        .fill(instances)
        .map((item, index) => (react_1.default.createElement(Typography_1.default, { key: index, sx: styles.skeletonText },
        react_1.default.createElement(Skeleton_1.default, { ...skeletonProps }))))));
};
// A skeleton component to render instead of an user card with actual information
const InfoCardSkeleton = (props) => {
    const { animation, variant } = props;
    const theme = (0, styles_1.useTheme)();
    const styles = getStyles({ theme });
    return (react_1.default.createElement(Grid_1.default, { sx: styles.skeletonGridContainer },
        react_1.default.createElement(SkeletonInfoText, { instances: 3, skeletonProps: { variant: variant, animation: animation } }),
        react_1.default.createElement(Grid_1.default, { sx: styles.skeletonGridItem },
            react_1.default.createElement(Email_1.default, { sx: styles.icon, opacity: ICON_OPACITY }),
            react_1.default.createElement(SkeletonInfoText, { instances: 1, skeletonProps: { variant: variant, animation: animation } })),
        react_1.default.createElement(Grid_1.default, { sx: styles.skeletonGridItem },
            react_1.default.createElement(Smartphone_1.default, { sx: styles.icon, opacity: ICON_OPACITY }),
            react_1.default.createElement(SkeletonInfoText, { instances: 1, skeletonProps: { variant: variant, animation: animation } }))));
};
exports.default = InfoCardSkeleton;
